import Alert from '@mui/material/Alert';
import { AppointmentProposalOption } from '../../../data-access/appointmentProposalOptions';

interface DeletedOptionAlertProps {
  option: AppointmentProposalOption | undefined;
}

const DeletedOptionAlert: React.FC<DeletedOptionAlertProps> = ({ option }) => {
  if (!option || option.status !== 'DELETED') {
    return null;
  }

  return (
    <Alert severity="error" sx={{ mb: 2 }}>
      {option.name} has been deleted and cannot be edited.
    </Alert>
  );
};

export default DeletedOptionAlert;
